import React from 'react';
/**
 * Returns whether a React element is an instance of a React class.
 *
 * Provides a workaround to deal with environments patched by hot module
 * replacement during development:
 * @see https://github.com/gaearon/react-hot-loader/issues/304
 * @param element
 * @param Component
 * @returns Whether `element` is an instance of the given `Component`.
 */

export default function isElementOfType(element, Component) {
  if (element == null || ! /*#__PURE__*/React.isValidElement(element) || typeof element.type === 'string') {
    return false;
  }

  if (process.env.NODE_ENV !== 'production') {
    return /*#__PURE__*/React.createElement(Component).type === element.type;
  }

  return element.type === Component;
}